import React, { useEffect } from 'react';
import Image from 'next/image';
import styles from './index.module.less';
const four0four = require('~/images/404_chicken.png');
import { useRouter } from 'next/router';
import { GetStaticProps } from 'next';
import { loadTranslation } from '@/libs';
import { bgc_img } from '@/pages';

export const getStaticProps: GetStaticProps = async ctx => {
  const translation = await loadTranslation(
    ctx.locale!,
    process.env.NODE_ENV === 'production'
  );
  return {
    props: {
      translation,
    },
  };
};

const Index: React.FC = () => {
  const router = useRouter();

  useEffect(() => {
    router.replace(`/${router.locale}/404`);
  }, []);

  return (
    <div className={styles.mj_404_container}>
      <Image className={styles.mj_404_bgc} fill src={bgc_img} alt="pic" />
      <Image
        className={styles.mj_404_pic}
        width={634}
        height={397}
        src={four0four}
        alt="404"
      />
    </div>
  );
};

export default Index;
